import '@angular/common/locales/global/es';

import { HttpClient } from '@angular/common/http';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';

export const SUPPORTED_LANGS = {
  en: 'en',
  es: 'es'
};

type SupportedLangsStrings = keyof typeof SUPPORTED_LANGS;

export const defaultLang = SUPPORTED_LANGS.en;

// Factory for the TranslateModule
export function createTranslateLoader(http: HttpClient): MultiTranslateHttpLoader {
  return new MultiTranslateHttpLoader(http as any, [
    { prefix: 'assets/i18n/', suffix: '.json' },
    { prefix: 'assets/i18n/instant/', suffix: '.json' }
  ]);
}

/**
 * Remove the country from the language (en-UK -> en)
 * @param language - The navigator language
 * @returns A translation json valid name
 */
export function formatLanguage(language: string): string {
  const lan = language.split('-')[0] as SupportedLangsStrings;

  return SUPPORTED_LANGS[lan] ? lan : defaultLang;
}
